import { useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import FullScreen from "src/atoms/FullScreen";
import CloseButton from "src/atoms/CloseButton";
import PopoverView from "src/components/PopoverView";
import { getFamilyName } from "src/modules/auth/duck/selectors";
import { getAvailableStations } from "src/modules/device/duck/selectors";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import environment from "src/utils/environment";
import LookingForStations from "../LookingForStations";
import StationPicker from "./StationPicker";
import MultiStationPicker from "./MultiStationPicker";

function SelectBabyStation({ stations, familyName, parentStation }) {
  const {
    previousBabyStation,
    handleConnect,
    hasConnectedStations,
    babyStationSelect,
    babyStations,
    isConnecting
  } = parentStation;
  const { supportsMultibaby } = environment;
  const notYetConnectedStations = useMemo(
    () =>
      stations.reduce((all, one) => {
        if (babyStations[one.jid]) return all;
        all.push(one);
        return all;
      }, []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stations]
  );

  const hasStations = notYetConnectedStations.length > 0;
  const hasMoreThenOneStations = notYetConnectedStations.length > 1;
  const Container = hasConnectedStations ? PopoverView : FullScreen;
  return (
    <Container>
      {hasConnectedStations && (
        <CloseButton absolute onClick={babyStationSelect.close} />
      )}
      {hasStations && supportsMultibaby && hasMoreThenOneStations && (
        <MultiStationPicker
          isInModal={hasConnectedStations}
          stations={notYetConnectedStations}
          isConnecting={isConnecting}
          onConnect={handleConnect}
        />
      )}
      {hasStations && (!supportsMultibaby || !hasMoreThenOneStations) && (
        <StationPicker
          isInModal={hasConnectedStations}
          stations={notYetConnectedStations}
          isConnecting={isConnecting}
          onConnect={handleConnect}
          familyName={familyName}
          previousBabyStation={previousBabyStation}
        />
      )}
      {!hasStations && !isConnecting && (
        <LookingForStations isConnecting={isConnecting} />
      )}
    </Container>
  );
}

function mapStateToProps(state) {
  return {
    stations: getAvailableStations(state),
    familyName: getFamilyName(state)
  };
}

const enhance = compose(withParentStation, connect(mapStateToProps));

export default enhance(SelectBabyStation);
